import classNames from 'classnames'
import moment, { type Moment } from 'moment'

import { type TextAreaEvent } from '@/pages/Dms/helper'
import { Datepicker, TextArea } from '@/shared'

import style from './NewItem.module.scss'

interface IProps {
    name: string
    startedAt: Moment
    finishedAt: Moment
    description: string
    // onChangeSpecialConditionsStartedAt: (e: moment.Moment, specialConditionId: string) => void
    // onChangeSpecialConditionsFinishedAt: (e: moment.Moment, specialConditionId: string) => void
    onChangeSpecialConditionsDescription: (e: TextAreaEvent) => void
    // onRemoveSpecialConditionFromList: (specialConditionId: string) => void
    onChangeNewStartedAt: (e: Moment) => void
    onChangeNewFinishedAt: (e: Moment) => void
    onPostNewSpecialCondition: () => void
    onCancel: () => void
}

export const NewItem = (props: IProps) => {
    const {
        // id,
        name,
        startedAt,
        finishedAt,
        description,
        onChangeNewStartedAt,
        onChangeNewFinishedAt,
        onPostNewSpecialCondition,
        onChangeSpecialConditionsDescription,
        onCancel
        // onChangeSpecialConditionsStartedAt,
        // onChangeSpecialConditionsFinishedAt,
        // onRemoveSpecialConditionFromList
    } = props
    // const [showDescription, setShowDescription] = useState<boolean>(false)

    // const onShowMoreDetails = () => setShowDescription((prev) => !prev)

    // const detailsBtn = showDescription ? 'Закрыть' : 'Описание'

    return (
        <div className={classNames(style.container)}>
            <div className={style.mainData}>
                <div className={style.itemName}>
                    <span>{name}</span>
                </div>
                <div className={style.dateWrapper}>
                    <Datepicker value={moment(startedAt)} onChange={(e: Moment) => onChangeNewStartedAt(e)} />
                </div>
                <div className={style.dateWrapper}>
                    <Datepicker value={moment(finishedAt)} onChange={(e: Moment) => onChangeNewFinishedAt(e)} />
                </div>
                <div className={style.actions}>
                    <button className={classNames(style.btn, style.descriptionBtn)} onClick={onPostNewSpecialCondition}>
                        {'Сохранить'}
                    </button>
                    <button className={classNames(style.btn, style.removeBtn)} onClick={onCancel}>
                        {'Отмена'}
                    </button>
                </div>
            </div>
            <div className={style.descriptionWrapper}>
                <TextArea
                    // className={style.field}
                    withMarkdown
                    value={description}
                    onChange={(e: TextAreaEvent) => onChangeSpecialConditionsDescription(e)}
                    placeholder={'Описание расширения'}
                />
            </div>
        </div>
    )
}
